// frontend/src/farm/farmZoomMemory.mjs
// The garden remembers the player's zoom: leaving and coming back (or reloading the page)
// restores it. Module memory first, localStorage behind it — every storage access is guarded,
// because a private window or blocked site data makes it throw. Pure (node --test): the
// storage is passed in.
import { ZOOM } from './farmView.mjs';

const KEY = 'stary-dom.farm.zoom';
let mem = null;
const clampZ = (z) => Math.min(ZOOM.max, Math.max(ZOOM.min, z));

export function browserStorage() {
  try { return globalThis.localStorage ?? null; } catch { return null; }
}

export function rememberedZoom(storage = browserStorage()) {
  if (mem !== null) return mem;
  try {
    const v = parseFloat(storage?.getItem(KEY));
    if (Number.isFinite(v)) mem = clampZ(v);
  } catch { /* unreadable storage: fall back to the default */ }
  return mem ?? 1;
}

export function rememberZoom(zoom, storage = browserStorage()) {
  mem = clampZ(zoom);
  try { storage?.setItem(KEY, String(mem)); } catch { /* memory still holds it */ }
}

export function _resetZoomMemory() { mem = null; }
